import { useState } from "react";
import { Transition } from "@headlessui/react";

const FindOutMethod = ({ type, name, setName, onChange }) => {
  const [bNext, setNext] = useState(false);

  const handleNameChange = (e) => {
    setNext(false);
    setName(e.target.value);
  };
  const handleNameBlur = () => {
    setNext(true);
  };

  const handleMethod = (e) => {
    onChange(e);
    setNext(false);
  };

  return (
    <div className="form-control">
      <input
        id="user_name"
        type="text"
        placeholder={type === "userId" ? "이름" : "아이디"}
        className={`input input-bordered`}
        onChange={handleNameChange}
        onBlur={handleNameBlur}
      />
      <Transition
        show={!!name && bNext}
        enter="transition-all duration-300 origin-top"
        enterFrom="opacity-0 scale-y-0"
        enterTo="opacity-100 scale-y-100"
        leave="transition-all duration-[200ms] origin-top"
        leaveFrom="opacity-100 scale-y-100"
        leaveTo="opacity-0 scale-y-0"
      >
        <div className="form-control">
          <label className="label text-sm m-0 font-bold text-zinc-500">
            인증 방법을 선택하세요.
          </label>
          <div className="flex flex-col gap-2">
            <button
              id="tel"
              className="btn btn-info btn-outline"
              onClick={handleMethod}
            >
              휴대전화번호 인증으로 찾기
            </button>
            <button
              id="email"
              className="btn btn-info btn-outline"
              onClick={handleMethod}
            >
              이메일 인증으로 찾기
            </button>
            {type === "userId" && (
              <button
                id="info"
                className="btn btn-info btn-outline"
                onClick={handleMethod}
              >
                정보 인증으로 찾기
              </button>
            )}
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default FindOutMethod;
